// tabDrop

bq.tabDrop = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.handle = false;
};

bq.tabDrop.DEFAULTS = {
  handleText: '<span class="fa fa-align-justify"></span> <span class="caret"><span>',
  handleTemplate: '<li class="dropdown hide pull-right tabdrop"><a class="dropdown-toggle handle-text" data-toggle="dropdown" href="#"></a><ul class="dropdown-menu"></ul></li>'
};

bq.tabDrop.prototype = {

  init: function(opt) {
    bq.debug.log("tabDrop : init()", this.$element);
    $(window).on('resize', {thiz: this}, this._catchResizeEvent);
    this._build();
    this._update();
  },

  _update: function() {
    var collection = [];
    this.handle.removeClass('hide'); //show the handle tab
    this.$element.append(this.handle.find('li')); //add ALL li's back

    var tmp = this.$element.find('>li').not('.tabdrop');

    var $top = tmp[0].offsetTop; //get first LI offsettop to compare all 2

    tmp.each(function(){
        if(this.offsetTop > $top) {
          collection.push(this);
        }
      }); //loop through, if they sit below 0, add them to collection

    if (collection.length > 0) { //we have some overflow
      collection = $(collection); //make them all jquery objects
      this.handle
          .find('ul')
          .empty() //clear out old ones
          .append(collection); //append new ones

      this.handle.removeClass('active'); //remove the active class

      if (this.handle.find('.active').length == 1) { this.handle.addClass('active'); } //if active exists, reset active status
    } else {
      this.handle.addClass('hide'); //no overflow, hide the handle
    }
  },

  _build: function() {
    this.handle = $(this.options.handleTemplate);
    this.handle.find('.handle-text').html(this.options.handleText);
    this.$element.prepend(this.handle);
  },

  _catchResizeEvent: function(e){
    var $this = e.data.thiz;
    return bq.helper.debounce($this._catchResizeEventDebounced(), 300);
  },

  _catchResizeEventDebounced: function() {
    this._update();
  }


};


// tabDrop PLUGIN DEFINITION
// =======================

var tabDropold = $.fn.tabDrop;

$.fn.tabDrop = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.tabDrop');
    var options = $.extend({}, bq.tabDrop.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.tabDrop', (data = new bq.tabDrop(this, options))); }
    data.init();
  });
};

$.fn.tabDrop.Constructor = bq.tabDrop;

// tabDrop NO CONFLICT
// =================

$.fn.tabDrop.noConflict = function () {
  $.fn.tabDrop = tabDropold;
  return this;
};

// tabDrop DATA-API
// ==============

bq.tabDropInit = function() {
  $('[data-bq="tabdrop"]').each(function () {
    var el = $(this);
    if(el.data('bq.tabDrop')) { return; }
    el.tabDrop(el.data());
  });
};

bq.init.push(bq.tabDropInit);
